<template>
  <div class="tree">
    <el-tree
      v-loading="treevloading"
      element-loading-text="节点移动中"
      ref="tree"
      :data="treeData"
      default-expand-all
      node-key="key"
      icon-class="el-icon-folder"
      @node-click="currentClick"
      @node-drag-start="handleDragStart"
      @node-drag-enter="handleDragEnter"
      @node-drag-leave="handleDragLeave"
      @node-drag-over="handleDragOver"
      @node-drag-end="handleDragEnd"
      @node-drop="handleDrop"
      :draggable="draggable"
      :allow-drop="allowDrop"
      :allow-drag="allowDrag"
      :filter-node-method="filterNode"
    >
    <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span v-show="showCurrentTool == data.key && $_has('o-edit')" @click.stop="rightClick(node,data,$event)">
          <svg t="1592272795253" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2826" width="32" height="32"><path d="M509.8 758.9c45.5 0.1 82.2 36.8 82.1 82.4-0.1 45.4-37 82.3-82.5 82.2-45.3 0-82.2-37.09999999-82.1-82.6 0.1-45.4 36.9-82 82.5-82z m-82.4-577c0-45.5 36.8-82.5 82.2-82.49999999 45.4-0.1 82.4 36.8 82.4 82.3 0 45.6-36.6 82.4-82.2 82.4s-82.4-36.6-82.4-82.20000001zM592 511.6c0 45.4-37.3 82.6-82.4 82.4-45.5-0.3-82.2-37.09999999-82.2-82.6 0-45.4 37.09999999-82.5 82.4-82.3 45.4 0.1 82.2 37 82.2 82.5z" p-id="2827" fill="#515151"></path></svg>
        </span>
      </span>
    </el-tree>
    <contextMenu ref="ctxMenu">
      <ul class="nav-ctx-menu">
        <li @click="configOrg(1)">添加子部门</li>
        <li @click="configOrg(2)">修改名称</li>
        <!-- <li @click="configOrg(3)">设置上级</li> -->
        <!-- <li @click="configOrg(4)">设置负责人</li> -->
        <li @click="configOrg(5)">删除</li>
      </ul>
    </contextMenu>
  </div>
</template>

<script>
  export default {
    props:{
      treeData:Array,
      filterText:String,
      draggable:{
        type:Boolean,
        default:true
      },
      treevloading:{
        type:Boolean,
        default:false
      }
    },
    data () {
      return {
        showCurrentTool:-1,
        currentData:{}
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
      handleDragStart (node, ev) {
        // console.log('drag start', node);
      },
      handleDragEnter (draggingNode, dropNode, ev) {
        // console.log('tree drag enter: ', dropNode.label);
      },
      handleDragLeave (draggingNode, dropNode, ev) {
        // console.log('tree drag leave: ', dropNode.label);
      },
      handleDragOver (draggingNode, dropNode, ev) {
        // console.log('tree drag over: ', dropNode.label);
      },
      handleDragEnd (draggingNode, dropNode, dropType, ev) {
        // console.log('tree drag end: ', draggingNode, dropNode, dropType);
      },
      handleDrop (draggingNode, dropNode, dropType, ev) {
        // console.log('tree drop: ', draggingNode, dropNode);
        this.$emit('dropEnd',{
          draggingNode,dropNode
        })
      },
      allowDrop (draggingNode, dropNode, type) {
        // console.log(draggingNode, dropNode, type)
        // if (dropNode.data.label === '二级 3-1') {
        //   return type !== 'inner';
        // } else {
        //   return true;
        // }
        return true

      },
      getNode(key){
        return this.$refs.tree.getNode(key)
      },
      allowDrag (draggingNode) {
        // return draggingNode.data.label.indexOf('三级 3-2-2') === -1;
        // console.log(draggingNode.level)
        if(draggingNode.level === 1){
          return false
        } else
        return true
      },
      configOrg(e){
        switch(e){
          case 1:
            this.$emit('addChildOrg',this.currentData)
            break;
          case 2:
            this.$emit('updateName',this.currentData)
            break;
          // case 3:
          //   this.$emit('updateParent',this.currentData)
          //   break;
          case 4:
            this.$emit('setPrincipal',this.currentData)
            break;
          case 5:
            this.$emit('deleteNode',this.currentData)
            break;
        }
      },
      currentClick(data,node,el){
        // console.log(data,node,el)
        this.showCurrentTool = data.key
        this.$emit('currentClick',data)
      },
      rightClick(node,data,e){
        // console.log(node,data,e)
        this.$refs.ctxMenu.open(e);
        this.currentData = data
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      }
    }
  };
</script>

<style scoped lang="scss">
  .tree{
    padding: 10px 0;
    // max-height:calc(100vh - 200px)
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .icon{
    width: 20px;
    height: 20px;
    margin-top: 3px;
  }
  .nav-ctx-menu {
    padding: 0;
    list-style: none;
    background-color: #ffffff;
    font-size: 12px;
    line-height: 12px;
    text-align: left;
    color: #515a6e;
    li{
      border: 1px solid #dcdfe6;
      border-bottom: none;
      padding: 8px 20px;
      cursor: pointer;
    }

    li:last-child{
      border-bottom: 1px solid #dcdfe6;
    }

    li:hover{
      background-color: #dcdfe6;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/myTree/index.vue